import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SelectField, TextField } from 'material-ui';
import { _l } from 'oxygen-i18n';

addTranslations({
  'en-US': {
    After: 'After',
    Hours: 'Hours',
    Days: 'Days',
    Months: 'Months'
  },
  'sv-SE': {
    After: 'Efter',
    Hours: 'Timmar',
    Days: 'Dagar',
    Months: 'Månader'
  }
});

const secondsInAnHour = 60 * 60;

const periodMultipliers = {
  0: 1,
  1: 24,
  2: 30 * 24
};

const secondsToPeriod = seconds => {
  let selectedIndex = 0;
  let amount = 0;
  Object.keys(periodMultipliers)
    .sort((a, b) => b - a)
    .forEach(index => {
      if (
        amount < 1 &&
        seconds % (secondsInAnHour * periodMultipliers[index]) === 0
      ) {
        amount = seconds / (secondsInAnHour * periodMultipliers[index]);
        selectedIndex = parseInt(index, 10);
      }
    });
  return { selectedIndex, amount };
};

const css = oxygenCss({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  input: {
    flexGrow: 0,
    flexShrink: 0,
    width: 100,
    padding: '2px 8px 2px 2px'
  },
  label: {
    flexGrow: 0,
    flexShrink: 0,
    width: 300,
    padding: '2px 8px 2px 2px'
  },
  dropdown: {
    flexGrow: 1,
    flexShrink: 0,
    padding: '2px 8px 2px 2px'
  }
});

export default class PeriodSelector extends Component {
  static propTypes = {
    children: PropTypes.node,
    onChange: PropTypes.func,
    value: PropTypes.number
  };

  state = secondsToPeriod(this.props.value);

  onChange() {
    const { onChange } = this.props;
    if (onChange) {
      const { selectedIndex } = this.state;
      if (!isNaN(this.state.amount)) {
        const amount = parseInt(this.state.amount, 10);
        const seconds =
          amount * secondsInAnHour * periodMultipliers[selectedIndex];
        onChange(seconds);
      }
    }
  }

  handleAmountChange = ({ target: { value } }) => {
    this.setState({ amount: value }, () => {
      this.onChange();
    });
  };

  handleSliceChange = (event, selectedIndex) => {
    this.setState({ selectedIndex }, () => {
      this.onChange();
    });
  };

  render() {
    const timeSlices = [
      { payload: 'hour', text: _l`Hours` },
      { payload: 'day', text: _l`Days` },
      { payload: 'mount', text: _l`Months` }
    ];
    const { amount, selectedIndex } = this.state;
    const { children } = this.props;
    return (
      <div className={css.container}>
        <div className={css.label}>{children}</div>
        <div className={css.input}>{_l`After`}</div>
        <div className={css.input}>
          <TextField
            fullWidth
            onChange={this.handleAmountChange}
            value={amount}
          />
        </div>
        <div className={css.dropdown}>
          <SelectField
            selectedIndex={selectedIndex}
            onChange={this.handleSliceChange}
            menuItems={timeSlices}
            fullWidth
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/PeriodSelector.js